import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-664b41ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "setting-block" }
const _hoisted_2 = { class: "block-title" }
const _hoisted_3 = { class: "title-desc" }
const _hoisted_4 = { class: "block-content" }
const _hoisted_5 = { class: "sub-title" }
const _hoisted_6 = {
  class: "row",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_7 = {
  class: "sub-title",
  style: {"margin-bottom":"0"}
}
const _hoisted_8 = {
  class: "row",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_9 = {
  key: 0,
  class: "setting-block reboot-container"
}
const _hoisted_10 = { class: "block-title" }
const _hoisted_11 = { class: "block-content" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = { class: "text" }
const _hoisted_14 = {
  key: 1,
  class: "setting-block"
}
const _hoisted_15 = {
  key: 0,
  class: "block-title"
}
const _hoisted_16 = { class: "block-content" }
const _hoisted_17 = { class: "sub-title" }
const _hoisted_18 = { class: "sub-title" }
const _hoisted_19 = { class: "sub-title" }
const _hoisted_20 = { class: "cm-ui-mb15 systems-wrapper" }
const _hoisted_21 = { class: "sub-title" }
const _hoisted_22 = { class: "inline-block-content cm-ui-mt15" }
const _hoisted_23 = { class: "cm-ui-mb30 cm-ui-ml30 cm-ui-mt10" }
const _hoisted_24 = {
  key: 1,
  class: "cm-ui-mb15 cm-ui-ml10"
}
const _hoisted_25 = {
  key: 2,
  class: "cm-ui-mb15 cm-ui-mt30 cm-ui-ml10"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DetailsSubscribeBar = _resolveComponent("DetailsSubscribeBar")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_MixSelectors = _resolveComponent("MixSelectors")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ContentAdaptLayout = _resolveComponent("ContentAdaptLayout")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (+_ctx.systemTab === _ctx.TerminalType.linux)
      ? (_openBlock(), _createBlock(_component_DetailsSubscribeBar, {
          key: 0,
          "linux-permission-key": _ctx.PermissionFe.linux_base_auth
        }, null, 8, ["linux-permission-key"]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createBlock(_component_ContentAdaptLayout, { class: "container" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, [
            _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.leakActiveScanFreqTitle')), 1),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.t('groupPolicySettings.leakActiveScanFreqNote')), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.t('groupPolicySettings.leakSubScanFreq')), 1),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_select, {
                size: "small",
                modelValue: _ctx.strategy.scan_frequency,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.strategy.scan_frequency) = $event)),
                onChange: _ctx.changeScanFrequency
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    type: 1,
                    label: _ctx.t('softwareDisabledEdit.freqDaily'),
                    value: 1
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    type: 2,
                    label: _ctx.t('softwareDisabledEdit.freqWeekly'),
                    value: 2
                  }, null, 8, ["label"]),
                  _createVNode(_component_el_option, {
                    type: 3,
                    label: _ctx.t('softwareDisabledEdit.freqMonthly'),
                    value: 3
                  }, null, 8, ["label"])
                ]),
                _: 1
              }, 8, ["modelValue", "onChange"])
            ]),
            _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.t('groupPolicySettings.leakSubScanTime')), 1),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_MixSelectors, {
                "main-switch": true,
                "mix-type": _ctx.strategy.scan_frequency,
                "s-key": "leakScanSelectors"
              }, null, 8, ["mix-type"])
            ])
          ])
        ]),
        (_ctx.systemTab === '1')
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.t('groupPolicySettings.leakRebootRemind')), 1),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.strategy.restart_remind_type,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.strategy.restart_remind_type) = $event)),
                  onChange: _ctx.setChangeStatus
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.leakRemindOnce')), 1)
                      ]),
                      _: 1
                    }),
                    _hoisted_12,
                    _createVNode(_component_el_radio, { label: 2 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.leakEvery')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.strategy.restart_remind_interval_min,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.strategy.restart_remind_interval_min) = $event)),
                      placeholder: _ctx.$t('common.phPleaseSelect'),
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.IntervalMinOptions, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: _ctx.t('groupPolicySettings.leakMinuteOption', { n: item.value }),
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "placeholder"]),
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.t('groupPolicySettings.leakRemindOnceSuffix')), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.systemTab === '1')
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (!_ctx.IS_JP_ONLY_BUILD)
                ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                    _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.leakRepairScheduledTitle')) + " ", 1),
                    _createVNode(_component_el_switch, {
                      class: "cm-ui-ml15",
                      modelValue: _ctx.strategy.repair_task_main_switch,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.strategy.repair_task_main_switch) = $event)),
                      onChange: _ctx.setChangeStatus
                    }, null, 8, ["modelValue", "onChange"])
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", _hoisted_16, [
                _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.t('groupPolicySettings.leakRepairFreq')), 1),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_select, {
                    size: "mini",
                    modelValue: _ctx.strategy.frequency,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.strategy.frequency) = $event)),
                    onChange: _ctx.changeFrequency,
                    disabled: !_ctx.strategy.repair_task_main_switch
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        type: 1,
                        label: _ctx.t('softwareDisabledEdit.freqDaily'),
                        value: 1
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        type: 2,
                        label: _ctx.t('softwareDisabledEdit.freqWeekly'),
                        value: 2
                      }, null, 8, ["label"]),
                      _createVNode(_component_el_option, {
                        type: 3,
                        label: _ctx.t('softwareDisabledEdit.freqMonthly'),
                        value: 3
                      }, null, 8, ["label"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange", "disabled"])
                ]),
                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.t('groupPolicySettings.leakRepairSchedule')), 1),
                _createElementVNode("div", null, [
                  _createVNode(_component_MixSelectors, {
                    "main-switch": _ctx.strategy.repair_task_main_switch,
                    "mix-type": _ctx.strategy.frequency,
                    "s-key": "leakRepairSelectors"
                  }, null, 8, ["main-switch", "mix-type"])
                ]),
                _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.t('groupPolicySettings.leakRepairOsTitle')), 1),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_el_checkbox_group, {
                    modelValue: _ctx.strategy.repair_os_list,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.strategy.repair_os_list) = $event)),
                    onChange: _ctx.setChangeStatus
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemOptions.options, (item) => {
                        return (_openBlock(), _createBlock(_component_el_checkbox, {
                          label: item.value,
                          key: item.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.display_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ]),
                _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.t('groupPolicySettings.leakRepairLevelTitle')), 1),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_el_checkbox_group, {
                    modelValue: _ctx.strategy.warn_level_list,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.strategy.warn_level_list) = $event)),
                    onChange: _ctx.setChangeStatus
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, { label: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.leakLevelHigh')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_checkbox, { label: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.leakLevelOptional')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue", "onChange"])
                ])
              ], 512), [
                [_vShow, _ctx.strategy.repair_task_main_switch]
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_el_button, {
                  type: "text",
                  onClick: _ctx.jumpLeak
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t('groupPolicySettings.leakIgnoredPatchesLink')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              (_ctx.operateType !== _ctx.OperateType.read)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      onClick: _ctx.saveLeakSetting,
                      disabled: !_ctx.data.hasEdit && _ctx.operateType !== _ctx.OperateType.add && 0
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('common.save')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"]),
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: _ctx.cancel
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('common.cancel')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.systemTab === '2' && _ctx.operateType !== _ctx.OperateType.read)
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
              _createVNode(_component_el_button, {
                type: "primary",
                disabled: !_ctx.hasPermission,
                size: "small",
                onClick: _ctx.saveLeakSetting
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('common.save')), 1)
                ]),
                _: 1
              }, 8, ["disabled", "onClick"]),
              _createVNode(_component_el_button, {
                size: "small",
                onClick: _ctx.cancel
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('common.cancel')), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })), [
      [_directive_loading, _ctx.loading]
    ])
  ], 64))
}